module.exports = __webpack_public_path__ + "static/media/pin-card.187c6ba1.jpg";